import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import classnames from 'classnames';

export function SectionList({
  links,
  className = '',
  listClassName = '',
  linksClassName = 'fw-bold',
  moreLinkClassName = 'fw-medium',
  trackingValueDecorator = item => item.name,
  dataTrackingId,
  moreLink = null,
  useSeparators = false,
  listStyle,
}) {
  const hasMoreLink = moreLink && moreLink.name && moreLink.href;

  return (
    <ul className={classnames('list-unstyled', listClassName)} style={listStyle}>
      {links.map((item, index) => {
        const itemText = item.title || item.name;
        const key = `${itemText}-${index}`;
        const isValidDate = !isNaN(new Date(item.date));
        const trackingId = item.dataTrackingId || dataTrackingId;
        const trackingValue = item.dataTrackingValue || trackingValueDecorator(item);
        return (
          <li key={key} className={className}>
            {useSeparators && !!index && <hr className="my-0" />}
            {item.relatedTitle && (
              <span className={classnames('xsmall d-block mb-0_25', { 'text-primary': item.sponsorTitle })}>
                {item.relatedTitle}
              </span>
            )}
            <a
              href={item.href}
              className={linksClassName}
              title={itemText}
              data-tracking-value={trackingValue}
              data-tracking-id={trackingId}
            >
              {item.name}
            </a>
            {isValidDate ? <div className="xsmall text-gray-darker">{dateFormat(item.date, 'longDate')}</div> : null}
          </li>
        );
      })}
      {!!hasMoreLink && (
        <li key={moreLink.name} className={className}>
          <a href={moreLink.href} className={moreLinkClassName} title={moreLink.name}>
            {moreLink.name}
            {!!moreLink?.accessibleText && (
              <span className="visually-hidden">&nbsp;{moreLink.accessibleText}</span>
            )}{' '}
            <span className="icon-arrow-right3 xsmall" aria-hidden />
          </a>
        </li>
      )}
    </ul>
  );
}

SectionList.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      href: PropTypes.string,
      date: PropTypes.string,
      dataTrackingId: PropTypes.string,
      dataTrackingValue: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
  listClassName: PropTypes.string,
  linksClassName: PropTypes.string,
  moreLinkClassName: PropTypes.string,
  trackingValueDecorator: PropTypes.func,
  dataTrackingId: PropTypes.string.isRequired,
  moreLink: PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string,
    accessibleText: PropTypes.string,
  }),
  useSeparators: PropTypes.bool,
  listStyle: PropTypes.shape({}),
};
